module.exports = __webpack_public_path__ + "static/curso-git-e-github-ninja-e940d8e9ec939223d259539cf0e85cad.png";